.form-subtitle {
  margin-top: calc(var(--spacer)* 4.5);
}

#policyName {
  display: flex;
  flex-direction: row;
}

#name-spinner {
  margin-left: calc(var(--spacer));
  margin-top:calc(var(--spacer) / 2);
}
